<ms-bugs-report
  *ngIf="reportType == 'BUGS'"
  [productDto]="productDto"
  [date]="date"
  [title]="title"
  [functionalAreasTable]="functionalAreasTable"
  [functionalAreasBugsTables]="functionalAreasDataTables"
  [isLoading]="isLoading"
  [expandedElement]="expandedElement"
  [localizedFields]="localizedFields"
></ms-bugs-report>
<ms-release-notes
  *ngIf="reportType == 'IMPROVEMENTS'"
  [productDto]="productDto"
  [date]="date"
  [title]="title"
  [functionalAreasTable]="functionalAreasTable"
  [functionalAreasImprovementsTables]="functionalAreasDataTables"
  [isLoading]="isLoading"
  [expandedElement]="expandedElement"
  [localizedFields]="localizedFields"
></ms-release-notes>
<ms-incidents
  *ngIf="reportType == 'INCIDENTS'"
  [productDto]="productDto"
  [functionalAreasTable]="functionalAreasTable"
  [functionalAreasIncidentsTables]="functionalAreasDataTables"
  [isLoading]="isLoading"
  [expandedElement]="expandedElement"
  [localizedFields]="localizedFields"
></ms-incidents>
